<!-- Row 1 table -->
<div
    class="grid grid-rows-7 grid-cols-product  pt-2 pb-4 border-b-normal hover:bg-select-row cursor-pointer"
    [ngClass]="[
        (searchType === SearchType.oportunities || searchType === SearchType.other) ? 'xl:table-row xl:grid-cols-product xl:pt-0 ' : 'xl:pt-5 xl:pb-8 mid-xl:pt-2 mid-xl:pb-4 mid-xl:table-row xl:grid-cols-product-7 mid-xl:grid-cols-product mid-xl:pt-0 ',
        featured ? 'bg-light-10 border-l-4-feature' : ''
    ]"
    (click)="onClickExtendInfo($event, item)"
>
    <!-- Image -->
    <!-- Mobile -->
    <div [ngClass]="[
        (searchType === SearchType.oportunities || searchType === SearchType.other)
            ? 'xl:table-cell'
            : 'mid-xl:table-cell'
        ]"
        class="col-span-1 row-span-2 sm:row-span-6  align-middle p-2 block sm:hidden xl:hidden mid-xl:hidden"  *ngIf="currentListType == ListType.big"><!-- hidden sm:block -->
        <ng-container>
            <div class="flex items-center justify-center relative">
                <img src="https://axhygnxuen.cloudimg.io/height/90/n/{{item.info.imagenarticulobig}}" (error)="onErrorImage($event)" alt="Rueda" class="max-h-14 min-w-56px"/>
            </div>
            <div *ngIf="typeLabel !== '' && (typeLabel || featured)" class="relative">
                <div
                    class="bg-featured text-white text-center font-bold text-2xs rounded-full w-full uppercase px-2 -mt-2">
                    {{ typeLabel ? (typeLabel | translate) : ('alert_explorer_title' | translate) }}
                </div>
            </div>
        </ng-container>
    </div>
    <!-- Desktop -->
    <div [ngClass]="[
        (searchType === SearchType.oportunities || searchType === SearchType.other)
            ? 'xl:table-cell'
            : 'mid-xl:table-cell'
        ]"
        class="col-span-1 row-span-2 sm:row-span-6  align-middle p-2 hidden sm:block"><!-- hidden sm:block -->
        <ng-container *ngIf="currentListType == ListType.big">
            <div class="flex items-center justify-center relative min-w-56px">
                <img src="https://axhygnxuen.cloudimg.io/height/90/n/{{item.info.imagenarticulobig}}" (error)="onErrorImage($event)" alt="Rueda" class="max-h-14"/>
            </div>
            <div *ngIf="typeLabel !== '' && (typeLabel || featured)" class="relative">
                <div
                    class="bg-featured text-white text-center font-bold text-2xs rounded-full w-full uppercase px-2 -mt-2">
                    {{ typeLabel ? (typeLabel | translate) : ('alert_explorer_title' | translate) }}
                </div>
            </div>
        </ng-container>
    </div>
    <!-- END Image -->

    <!-- Description & Brand -->
    <div
    [ngClass]="[
        currentListType === ListType.big ? 'col-span-3' : 'col-span-4 sm:col-span-2 md:col-span-3 px-4 sm:px-2',
        (searchType === SearchType.oportunities || searchType === SearchType.other) ? 'xl:table-cell col-span-3' : 'xl:col-span-1 mid-xl:col-span-3 midcol-span-3 mid-xl:table-cell',
    ]"
    class="align-middle p-2"
    >
        <div class="flex items-center">
            <div
                *ngIf="currentListType === ListType.small && typeLabel !== '' && (typeLabel || featured)"
                class="bg-featured text-white text-center font-bold text-2xs rounded-full uppercase px-2 mr-2" style="max-width:fit-content">
                {{ typeLabel ? (typeLabel | translate) : ('alert_explorer_title' | translate) }}
            </div>
            <img *ngIf=item.info.imagenmarca src="https://axhygnxuen.cloudimg.io/cdn/n/n/{{item.info.imagenmarca}}" (error)="onErrorImage($event)" alt="Marca" class="max-h-6 max-w-6rem"/>
        </div>
        <div class="grid gap-1 mt-2">
            <!-- Description -->
            <h2 class="">{{ item.info.nombre }}</h2>
            <div class="flex flex-wrap gap-x-3 gap-y-1 font-medium">
                <div class="flex gap-2" *ngIf="item.info.veretiquetado">
                    <!-- Consumption -->
                    <div *ngIf="item.info.consumo" class="flex items-center gap-1.5">
                        <span><img src="./assets2023/img/icons/consumption.svg" alt="Consumo" width="14"
                                    height="14"/> </span>
                        <span class="whitespace-nowrap">{{item.info.consumo}}</span>
                    </div>
                    <!-- Lluvia -->
                    <div *ngIf="item.info.agarre" class="flex items-center gap-1.5">
                        <span><img src="./assets2023/img/icons/rain.svg" alt="Lluvia" width="14" height="14"/> </span>
                        <span class="whitespace-nowrap">{{item.info.agarre}}</span>
                    </div>
                    <!-- Sound -->
                    <div *ngIf="item.info.ruido" class="flex items-center gap-1.5">
                        <span><img src="./assets2023/img/icons/sound.svg" alt="Ruido" width="14" height="14"/> </span>
                        <span class="whitespace-nowrap">{{item.info.ruido}} dB</span>
                    </div>
                    <div *ngIf="item.info.nieve" class="flex items-center gap-1.5">
                        <span><img src="assets/img/ico-snow.svg" alt="Nieve" width="14" height="14"/> </span>
                        <span class="whitespace-nowrap">{{ 'product_snow_homologation' | translate }}</span>
                    </div>
                </div>
                <div class="xl:w-full" *ngIf="item.equivalencia">
                    <p class="bg-primary text-white px-2 py-1 w-fit">{{ 'product_equivalence' | translate }}</p>
                </div>
            </div>
        </div>
    </div>
    <!-- END Description & Brand -->

    <!-- Characteristics -->
    <div
    [ngClass]="[
        currentListType === ListType.big ? 'col-span-3 gap-y-1' : 'col-span-1 lg:col-span-3 sm:flex-col sm:justify-end md:justify-start md:flex-row pl-4 sm:pl-0 md:pl-2 pr-4 md:pr-2',
        (searchType === SearchType.oportunities || searchType === SearchType.other) ? 'xl:col-span-4 xl:table-cell xl:flex-col' : 'xl:mt-3 mid-xl:-mt-2.5 xl:col-span-1 mid-xl:col-span-3 mid-xl:table-cell mid-xl:max-w-12rem mid-xl:border-0 mid-xl:gap-2 mid-xl:flex-col',
    ]"
    class="align-middle p-2 flex flex-wrap gap-x-2 sm:gap-x-4 -mt-2.5">
        <div class="text-xs md:text-sm">{{ item.info.tipo | titleCase | translate }}</div>
        <div class="text-xs md:text-sm" *ngIf="searchType !== 'industrial' && item.info.allseasons">{{ 'product_seasons_all' | translate }}</div>
        <div class="text-xs md:text-sm" *ngIf="searchType !== 'industrial' && item.info.invierno">{{ 'product_seasons_winter' | translate }}</div>
        <div class="text-xs md:text-sm" *ngIf="searchType !== 'industrial' && item.info.electrico">{{ 'product_electrico' | translate }}</div>
        <div class="text-xs md:text-sm" *ngIf="(searchType === SearchType.car || searchType === SearchType.moto) && item.info.semiSlick">Semi Slick</div>
        <div class="text-xs md:text-sm" *ngIf="searchType !== 'industrial' && item.info.runflat">Runflat</div>
        <div class="text-xs md:text-sm" *ngIf="searchType !== 'industrial' && item.info.codigoMS">M+ S</div>
        <div class="text-xs md:text-sm" *ngIf="searchType !== 'industrial' && item.info.sealInside">Seal Inside</div>
        <div class="text-xs md:text-sm" *ngIf="searchType !== 'industrial' && item.info.protector">Protector Llanta</div>
        <div class="text-xs md:text-sm" *ngIf="item.info.posicion">{{ item.info.posicion | titleCase }}</div>
        <div class="text-xs md:text-sm" *ngIf="searchType !== 'industrial' && item.info.gama">{{item.info.gama | titleCase}}</div>
        <div class="text-xs md:text-sm" *ngIf="item.info.uso">{{item.info.uso | titleCase}}</div>
        <div class="text-xs md:text-sm" *ngIf="item.info.estructura">{{item.info.estructura | titleCase}}</div>
        <div class="text-xs md:text-sm" *ngIf="searchType !== 'industrial' && item.info.homologacion">{{item.info.homologacion | titleCase}}</div>
    </div>
    <!-- END Characteristics -->

    <!-- <div
    [ngClass]="[
        (searchType === SearchType.oportunities || searchType === SearchType.other) ? '' : 'mid-xl:hidden xl:block',
    ]" class=" hidden  col-span-5 px-2">
        <div class="xl:border-b xl:border-soft w-full"></div>
    </div> -->

    <!-- Stock y Info -->
    <div
    [ngClass]="[
        (searchType === SearchType.oportunities || searchType === SearchType.other) ? 'xl:table-cell mid-xl:mt-0' : 'mid-xl:table-cell mid-xl:mt-0',
    ]"
    class="col-span-4 sm:col-span-3 xl:col-span-1  align-middle py-2 px-4 sm:px-2 xl:mt-3 ">
        <div class="flex items-start gap-4 border-t border-soft pt-3 xl:pt-0 xl:border-t-0">
            <div
            [ngClass]="[
                (searchType === SearchType.oportunities || searchType === SearchType.other) ? 'xl:bg-transparent xl:p-0 xl:rounded-none' : 'mid-xl:bg-transparent mid-xl:p-0 mid-xl:rounded-none',
            ]"
            class="flex items-center gap-1 group w-55px min-w-55px bg-soft p-1 rounded-sm " (click)="onClickProductStock(item.info.codigo, user, true, item, $event)">
                <span class="font-medium text-xs md:text-sm">
                    <ng-container *ngIf="user.tipoUsuario === 'COMERCIAL'">
                        {{ item.stockFull }}
                    </ng-container>
                    <ng-container *ngIf="user.tipoUsuario !== 'COMERCIAL'">
                        {{ item.stockFull == 0 ? '0' : item.stockMostrarFull | slice:2:5 }}
                    </ng-container>
                </span>

                <!-- Info -->
                <div>
                    <button class="openModalStock flex items-center w-5 h-5">
                        <svg class="stroke-primary group-hover:stroke-secondary" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_558_30307)">
                                <path d="M2.125 8.5C2.125 9.33718 2.28989 10.1662 2.61027 10.9396C2.93064 11.7131 3.40022 12.4158 3.99219 13.0078C4.58417 13.5998 5.28694 14.0694 6.06039 14.3897C6.83384 14.7101 7.66282 14.875 8.5 14.875C9.33718 14.875 10.1662 14.7101 10.9396 14.3897C11.7131 14.0694 12.4158 13.5998 13.0078 13.0078C13.5998 12.4158 14.0694 11.7131 14.3897 10.9396C14.7101 10.1662 14.875 9.33718 14.875 8.5C14.875 6.80924 14.2033 5.18774 13.0078 3.99219C11.8123 2.79665 10.1908 2.125 8.5 2.125C6.80924 2.125 5.18774 2.79665 3.99219 3.99219C2.79665 5.18774 2.125 6.80924 2.125 8.5Z" stroke-width="1.0625" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M8.5 6.375H8.50759" stroke-width="1.0625" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M7.7915 8.5H8.49984V11.3333H9.20817" stroke-width="1.0625" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_558_30307">
                                    <rect width="17" height="17" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </button>
                </div>
                <!-- END Info -->
            </div>

            <div>
                <!-- Btn Notificar disponibilidad-->
                <ng-container *ngIf="item.stockFull == 0 && user.tipoUsuario !== 'COMERCIAL'">
                    <div class="relative group">
                        <button
                            (click)="onClickNotifyDisponibility($event)"
                            [ngClass]="{'bg-warning-light border-warning-light hover:border-warning': !isNotified, 'bg-primary-5': isNotified}"
                            [disabled]="isNotified"
                            class="flex items-center gap-2 rounded p-2 border"
                        >
                            <img src="./assets2023/img/icons/bell.svg" alt="19" height="19">
                            <div class="font-medium text-sm text-left flex flew-wrap">
                                {{'product_stock_notificate_disponibility' | translate}}
                            </div>
                        </button>
                        <!-- Popover -->
                        <div style="bottom:47px;left:0px" [hidden]="isNotified" class="z-30 absolute invisible text-xs w-max max-w-250px transform p-4 text-left border bg-white rounded shadow-lg opacity-0 group-hover:visible group-hover:opacity-100 transition-opacity duration-300">
                            {{ 'info_tooltip_no_stock' | translate }}
                            <svg class="absolute h-3 left-2.5" style="bottom: -12px;" x="0px" y="0px" viewBox="0 0 255 255" xml:space="preserve">
                                <polygon class="fill-white" points="0,0 127.5,127.5 255,0"></polygon>
                            </svg>
                        </div>
                    </div>
                    <!-- END Popover -->
                </ng-container>
                <div *ngIf="item.stockFull != 0" class="flex items-center flex-wrap gap-x-2 gap-y-0">
                    <div class="font-semibold text-xs md:text-sm">
                        <div
                            class="h-2 w-2 rounded-full float-left mt-1 mr-1"
                            [ngClass]="{'bg-success': item.colorEntrega === 1, 'bg-warning': item.colorEntrega === 2, 'bg-secondary': item.colorEntrega === 3}"
                        >
                        </div>
                        <ng-container *ngIf="isToday(item.fechaEntrega)">
                            {{'stockHoy' | translate }} </ng-container>
                        <ng-container *ngIf="isTomorrow(item.fechaEntrega)">
                            {{'stockMañana' | translate }} </ng-container>
                        <ng-container *ngIf="!isToday(item.fechaEntrega) && !isTomorrow(item.fechaEntrega)">
                            {{item.fechaEntrega}}
                            {{'product_stock_until'|
                            translate}} </ng-container>
                        <span class="whitespace-nowrap inline" translate [translateParams]="{ Count: item.stockMasProximo }">product_stock_units</span>
                    </div>
                    <span class="text-xs">
                        <ng-container
                            *ngIf="item.stockMostrar !== '0' else OtherWareHouse">
                            ({{user?.almacenNombre.trim() |
                            titleCase}})
                        </ng-container>
                        <ng-template
                            #OtherWareHouse>
                            ({{'product_stock_other_stores'
                            | translate}})
                        </ng-template>
                    </span>
                </div>
                <div class="text-xs">
                    <ng-container *ngIf="item.fechaHoraCorte">
                        {{'product_stock_before_hour'|translate}}
                        {{ item.horaCorte }}
                        <ng-container *ngIf="today !== item.fechaCorte">
                            {{ item.fechaCorte | date: 'dd MMM'}}
                        </ng-container>
                    </ng-container>
                    <button
                        class="font-semibold underline hover:no-underline"
                        (click)="onClickProductStock(item.info.codigo, user, true, item, $event)">
                        {{'product_stock_more_info' | translate}}
                    </button>
                </div>
                <!-- Sin Stock Comercial -->
                <div
                    *ngIf="item.stockFull == 0 && user.tipoUsuario === 'COMERCIAL'"
                    class="h-2 w-2 rounded-full"
                >
                    {{ item.fechaEntrega }}
                </div>
            </div>
        </div>
    </div>
    <!-- END Stock y Info -->

    <!--Tarifas y UPVs-->
    <div *ngIf="user?.tipoUsuario === 'COMERCIAL'"
    [ngClass]="[
        (searchType === SearchType.oportunities || searchType === SearchType.other) ? 'xl:table-cell mid-xl:mt-0 xl:flex-col' : 'mid-xl:table-cell mid-xl:mt-0 mid-xl:flex-col',
    ]"
    class="col-span-2 sm:col-span-2 lg:col-span-1 xl:mt-3  align-middle py-2 px-4 sm:px-2 flex items-baseline gap-2">
        <div
        [ngClass]="[
            (searchType === SearchType.oportunities || searchType === SearchType.other) ? 'xl:bg-transparent xl:p-0 xl:rounded-none' : 'mid-xl:bg-transparent mid-xl:p-0 mid-xl:rounded-none',
        ]"
        class="flex items-center gap-1 mb-2 group text-xs md:text-sm bg-soft p-1 rounded-sm" (click)="onClickProductRates($event)">
            {{'product_table_rates'|translate}}
            <div>
                <button class="openModalStock flex items-center w-5 h-5">
                    <svg class="stroke-primary group-hover:stroke-secondary" fill="none" height="17" viewBox="0 0 17 17" width="17" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_558_30307)">
                            <path d="M2.125 8.5C2.125 9.33718 2.28989 10.1662 2.61027 10.9396C2.93064 11.7131 3.40022 12.4158 3.99219 13.0078C4.58417 13.5998 5.28694 14.0694 6.06039 14.3897C6.83384 14.7101 7.66282 14.875 8.5 14.875C9.33718 14.875 10.1662 14.7101 10.9396 14.3897C11.7131 14.0694 12.4158 13.5998 13.0078 13.0078C13.5998 12.4158 14.0694 11.7131 14.3897 10.9396C14.7101 10.1662 14.875 9.33718 14.875 8.5C14.875 6.80924 14.2033 5.18774 13.0078 3.99219C11.8123 2.79665 10.1908 2.125 8.5 2.125C6.80924 2.125 5.18774 2.79665 3.99219 3.99219C2.79665 5.18774 2.125 6.80924 2.125 8.5Z" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.0625"></path>
                            <path d="M8.5 6.375H8.50759" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.0625"></path>
                            <path d="M7.7915 8.5H8.49984V11.3333H9.20817" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.0625"></path>
                        </g>
                        <defs>
                            <clipPath id="clip0_558_30307">
                                <rect fill="white" height="17" width="17"></rect>
                            </clipPath>
                        </defs>
                    </svg>
                </button>
            </div>
        </div>
        <div
        [ngClass]="[
            (searchType === SearchType.oportunities || searchType === SearchType.other) ? 'xl:bg-transparent xl:p-0 xl:rounded-none' : 'mid-xl:bg-transparent mid-xl:p-0 mid-xl:rounded-none',
        ]"
        class="flex items-center gap-1 group text-xs md:text-sm bg-soft p-1 rounded-sm " (click)="onClickProductUPVS($event)">
            {{'product_table_upvs'|translate}}
            <div>
                <button class="openModalStock flex items-center w-5 h-5">
                    <svg class="stroke-primary group-hover:stroke-secondary" fill="none" height="17" viewBox="0 0 17 17" width="17" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_558_30307)">
                            <path d="M2.125 8.5C2.125 9.33718 2.28989 10.1662 2.61027 10.9396C2.93064 11.7131 3.40022 12.4158 3.99219 13.0078C4.58417 13.5998 5.28694 14.0694 6.06039 14.3897C6.83384 14.7101 7.66282 14.875 8.5 14.875C9.33718 14.875 10.1662 14.7101 10.9396 14.3897C11.7131 14.0694 12.4158 13.5998 13.0078 13.0078C13.5998 12.4158 14.0694 11.7131 14.3897 10.9396C14.7101 10.1662 14.875 9.33718 14.875 8.5C14.875 6.80924 14.2033 5.18774 13.0078 3.99219C11.8123 2.79665 10.1908 2.125 8.5 2.125C6.80924 2.125 5.18774 2.79665 3.99219 3.99219C2.79665 5.18774 2.125 6.80924 2.125 8.5Z" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.0625"></path>
                            <path d="M8.5 6.375H8.50759" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.0625"></path>
                            <path d="M7.7915 8.5H8.49984V11.3333H9.20817" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.0625"></path>
                        </g>
                        <defs>
                            <clipPath id="clip0_558_30307">
                                <rect fill="white" height="17" width="17"></rect>
                            </clipPath>
                        </defs>
                    </svg>
                </button>
            </div>
        </div>
    </div>

    <!--Descuentos-->
    <div *ngIf="user?.tipoUsuario === 'COMERCIAL'"
    [ngClass]="[
        (searchType === SearchType.oportunities || searchType === SearchType.other) ? 'xl:table-cell mid-xl:mt-0' : 'mid-xl:table-cell mid-xl:mt-0',
    ]"
     class="col-span-2 sm:col-span-1 align-middle py-2 px-4 sm:px-2 xl:mt-3">
        <div
        [ngClass]="[
            (searchType === SearchType.oportunities || searchType === SearchType.other) ? 'xl:flex-col' : 'mid-xl:flex-col',
        ]"
        class="flex flex-wrap  items-center gap-x-2 gap-y-1 font-medium">
            <p
            [ngClass]="[
                (searchType === SearchType.oportunities || searchType === SearchType.other) ? 'xl:hidden' : 'mid-xl:hidden',
            ]" class="text-xs uppercase w-full ">{{'product_table_discount' | translate }}</p>
            <p class="text-secondary text-xs md:text-sm">
                {{item?.rates.base.preDto1 | number:'1.0-2':fr}} %
            </p>
            <p class="text-secondary text-xs">
                {{item?.rates.base.preDto2 | number:'1.0-2':fr}} %
            </p>
            <p *ngIf="item?.rates.base.preOfe && item?.rates.base.preSst" class="text-xs">**</p>
            <p *ngIf="item?.rates.base.preOfe && !item?.rates.base.preSst" class="text-xs">*</p>
        </div>
    </div>

    <!-- PVR desktop -->
    <div *ngIf="searchSettings?.mostrarPVR"
    [ngClass]="[
        (searchType === SearchType.oportunities || searchType === SearchType.other) ? 'xl:table-cell xl:block' : 'mid-xl:table-cell mid-xl:block',
    ]"
    class="hidden align-middle p-2 whitespace-no-wrap">
        <div class="font-bold">
            {{item?.precioConsejo | currency:(us.currency$ | async):'symbol':'1.2-2' | noZero}}
        </div>
    </div>
    <!-- END PVR -->

    <!-- Price desktops-->
    <div *ngIf="user?.showPrice && searchSettings?.mostrarCoste"
    [ngClass]="[
        (searchType === SearchType.oportunities || searchType === SearchType.other) ? 'xl:block xl:table-cell' : 'mid-xl:block mid-xl:table-cell',
    ]"
    class="hidden align-middle p-2 whitespace-no-wrap">
        <div class="font-bold group relative" (click)="onClickProductPrices($event)">
            {{item?.rates.base.precioMostrarBusqueda | currency:(us.currency$ | async):'symbol':'1.2-2' | noZero}}
            <!-- <ng-container *ngIf="item?.precioTachado">
                <span class="text-xs text-secondary block line-through">{{item?.precioTachado | currency:(us.currency$ | async):'symbol':'1.2-2' | noZero}}</span>
            </ng-container>
            {{item?.precioMostrar | currency:(us.currency$ | async):'symbol':'1.2-2' | noZero}} -->
            <span class="text-secondary text-xs block" *ngIf="showBRateBuyButton() || showCRateBuyButton()">{{ 'product_table_batch_offer' | translate }}</span>
            <span class="bg-soft bg-soft p-1 rounded-sm block text-xs mt-0.5" *ngIf="showBRateBuyButton()">{{
                item?.rates.b.cantidad }} x
                {{item?.rates.b.precioMostrarBusqueda |
                currency:(us.currency$ | async):'symbol':'1.2-2'}}</span>
            <span class="block" *ngIf="showCRateBuyButton()">{{
                item?.rates.c.cantidad }} x
                {{item?.rates.c.precioMostrarBusqueda |
                currency:(us.currency$ | async):'symbol':'1.2-2'}}</span>

            <!-- Popover -->
            <div style="bottom:27px;left:0px" class="z-30 absolute invisible text-xs w-max max-w-250px transform p-4 text-left border bg-white rounded shadow-lg opacity-0 group-hover:visible group-hover:opacity-100 transition-opacity duration-300">
                {{ 'click_to_see_breakdown' | translate }}
                <svg class="absolute h-3 left-2.5" style="bottom: -12px;" x="0px" y="0px" viewBox="0 0 255 255" xml:space="preserve">
                    <polygon class="fill-white" points="0,0 127.5,127.5 255,0"></polygon>
                </svg>
            </div>
        </div>
    </div>
    <!-- END Price -->

    <!-- Promo -->
    <div
    [ngClass]="{
        'hidden': !(item.resultadosTipo.length > 0),
        'xl:table-cell xl:text-center': searchType === SearchType.oportunities || searchType === SearchType.other,
        'mid-xl:table-cell mid-xl:text-center xl:mt-3 mid-xl:mt-0': searchType !== SearchType.oportunities && searchType !== SearchType.other
    }"
     class="col-span-1  align-middle py-2 px-4 sm:px-2 ">
        <div class="flex flex-wrap items-center gap-5 md:gap-8">
            <div *ngIf="item.resultadosTipo.length > 0">
                <div
                [ngClass]="[
                    (searchType === SearchType.oportunities || searchType === SearchType.other) ? 'xl:hidden' : 'mid-xl:hidden',
                ]"  class=" text-xs uppercase hidden md:block">{{'checkout_conditions_pay_promos' | translate}}</div>
                <div
                [ngClass]="[
                    (searchType === SearchType.oportunities || searchType === SearchType.other) ? '' : 'xl:flex-col mid-xl:flex-row xl:mt-2 mid-xl:mt-0',
                ]"
                class="flex gap-2 flex-col sm:flex-row ">
                    <div *ngFor="let resultado of item.resultadosTipo"
                    [ngClass]="[
                        (searchType === SearchType.oportunities || searchType === SearchType.other) ? '' : '',
                    ]"
                    class="relative group">
                        <div>
                            <img (click)="onClickPromo($event, resultado)" [src]="'https://axhygnxuen.cloudimg.io/v7/' + resultado.burl_miniatura" (error)="onErrorImage($event)" alt="" class="w-65px min-w-65px"/>
                        </div>
                        <ng-container *ngIf="resultado.btexto?.trim()">
                            <div
                                [ngClass]="{'hidden invisible opacity-0': !resultado.tooltipOpen}"
                                style="bottom:36px;"
                                class="sm:block bottom-[30px] left-0 lg:right-0 lg:left-auto z-30 absolute text-xs w-max max-w-250px transform p-4 text-left border bg-white rounded shadow-lg group-hover:visible group-hover:opacity-100 transition-opacity duration-300">
                                {{resultado.btexto}}
                                <svg class="absolute h-3 left-2.5 lg:right-2.5 lg:left-auto" style="bottom: -10px;" x="0px" y="0px" viewBox="0 0 255 255" xml:space="preserve">
                                    <polygon class="fill-white" points="0,0 127.5,127.5 255,0"></polygon>
                                </svg>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- END Promo -->
    <div
    [ngClass]="{
        'hidden': !searchSettings?.mostrarPVR,
        'xl:hidden xl:mt-0': searchType === SearchType.oportunities || searchType === SearchType.other,
        'mid-xl:hidden mid-xl:mt-0': searchType !== SearchType.oportunities && searchType !== SearchType.other
    }"
     class="col-span-1  align-middle py-2 px-4 sm:px-2 xl:mt-3 ">
        <!-- Mobile PVR -->
        <div *ngIf="searchSettings?.mostrarPVR"
        [ngClass]="[
            (searchType === SearchType.oportunities || searchType === SearchType.other) ? 'xl:hidden' : 'mid-xl:hidden',
        ]"
        class="">
            <div class="text-xs uppercase">{{user.tipoPrecioConsejo }}</div>
            <div class="font-bold whitespace-nowrap">{{item?.precioConsejo | currency:(us.currency$ | async):'symbol':'1.2-2' | noZero}}</div>
        </div>
    </div>

    <!-- Units and button (Price mobile) -->
    <div
        [ngClass]="[
            (searchType === SearchType.oportunities || searchType === SearchType.other) ? 'xl:table-cell' : 'mid-xl:table-cell',
        ]"
        class="col-span-4 xl:col-span-6 align-middle pt-2 px-4 sm:px-2">
        <div
        [ngClass]="[
            (searchType === SearchType.oportunities || searchType === SearchType.other) ? 'xl:flex-nowrap xl:justify-end xl:pt-0 xl:border-t-0' : 'mid-xl:flex-nowrap mid-xl:justify-end mid-xl:pt-0 mid-xl:border-t-0',
        ]"
        class="flex flex-wrap  items-center gap-3 justify-between sm:justify-center  border-t border-soft pt-2 sm:pt-3 ">

            <!-- Price Mobile -->
            <div *ngIf="user?.showPrice && searchSettings?.mostrarCoste"
                [ngClass]="[
                    (searchType === SearchType.oportunities || searchType === SearchType.other) ? 'xl:hidden' : 'mid-xl:hidden',
                ]"
                class="" (click)="onClickProductPrices($event)">
                <!--<div class="text-xs uppercase">{{ 'product_rate_price' | translate | titleCase }}</div>-->
                <div class="font-bold whitespace-nowrap">
                    {{item?.rates.base.precioMostrarBusqueda | currency:(us.currency$ | async):'symbol':'1.2-2' | noZero}}
                    <span class="text-secondary text-xs block" *ngIf="showBRateBuyButton() || showCRateBuyButton()">{{ 'product_table_batch_offer' | translate }}</span>
                    <span class="bg-soft bg-soft p-1 rounded-sm block text-xs mt-0.5" *ngIf="showBRateBuyButton()">{{
                        item?.rates.b.cantidad }} x
                        {{item?.rates.b.precioMostrarBusqueda |
                        currency:(us.currency$ | async):'symbol':'1.2-2'}}
                    </span>
                    <span class="block" *ngIf="showCRateBuyButton()">{{
                        item?.rates.c.cantidad }} x
                        {{item?.rates.c.precioMostrarBusqueda |
                        currency:(us.currency$ | async):'symbol':'1.2-2'}}
                    </span>
                </div>
            </div>

            <!-- Units -->
            <div
                [ngClass]="[
                    (searchType === SearchType.oportunities || searchType === SearchType.other) ? 'xl:flex-1' : 'mid-xl:flex-1',
                ]" class=" sm:flex-none flex items-center gap-3 group">
                <button
                    (click)="decreasePreSelectedUnits($event)"
                    [ngStyle]="{'opacity': item.preSelectedUnits <= 1 ? 0 : 1}"
                    [disabled]="item.preSelectedUnits <= 1"
                    class="flex items-center justify-center rounded-full bg-info border border-info hover:border-primary w-7 h-7 transition-all ease-in-out">
                    <svg width="6" height="2" viewBox="0 0 6 2" fill="primary"
                            xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M0 1.12539C0 0.794014 0.268624 0.525391 0.599994 0.525391H5.40001C5.73138 0.525391 6 0.794014 6 1.12539C6 1.45676 5.73138 1.72538 5.40001 1.72538H0.599994C0.268652 1.72538 0 1.45676 0 1.12539Z"/>
                    </svg>
                </button>
                <span class="text-primary text-md font-medium">
                    {{ item.preSelectedUnits }}
                </span>
                <button
                    (click)="increasePreSelectedUnits($event)"
                    [ngStyle]="{'opacity': item.preSelectedUnits >= item.cantMax ? 0 : 1}"
                    [disabled]="item.preSelectedUnits >= item.cantMax"
                    class="flex items-center justify-center rounded-full bg-info border border-info hover:border-primary w-7 h-7 transition-all ease-in-out">
                    <svg width="6" height="7" viewBox="0 0 6 7" fill="primary"
                            xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M0 3.125C0 2.79363 0.268624 2.52501 0.599994 2.52501H2.40001V0.724994C2.40001 0.393624 2.66863 0.125 3 0.125C3.33137 0.125 3.59999 0.393624 3.59999 0.724994V2.52501H5.40001C5.73138 2.52501 6 2.79363 6 3.125C6 3.45637 5.73138 3.72499 5.40001 3.72499H3.59999V5.52501C3.59999 5.85638 3.33137 6.125 3 6.125C2.66863 6.125 2.40001 5.85638 2.40001 5.52501V3.72499H0.599994C0.268652 3.72499 0 3.45637 0 3.125Z"/>
                    </svg>
                </button>
            </div>
            <!-- END Units -->

            <!-- Component button (views/components/button -->
            <ng-container *ngIf="isBuyable(item) || searchType !== SearchType.oportunities">
                <button
                    [ngClass]="[
                        (searchType === SearchType.oportunities || searchType === SearchType.other) ? ' xl:hidden' : ' mid-xl:hidden',
                    ]"
                    class="text-xs md:text-sm text-white bg-secondary border-secondary hover:bg-white hover:text-primary hover:border-primary  font-semibold text-sm rounded border transition duration-300 px-8 py-1.5"
                    (click)="onClickBuyProduct($event)"
                >
                {{ 'product_table_buy_btn' | translate }}
                </button>

                <button
                    [ngClass]="[
                        (searchType === SearchType.oportunities || searchType === SearchType.other) ? ' xl:inline' : ' mid-xl:inline',
                    ]"
                    class="hidden  text-white bg-secondary border-secondary hover:bg-white hover:text-primary hover:border-primary rounded border transition duration-300 px-2 py-1"
                    (click)="onClickBuyProduct($event)"
                >
                    <span class="flex items-center gap-2 whitespace-nowrap">
                        {{ 'common_buy' | translate }}
                    </span>
                </button>
            </ng-container>
        </div>
    </div>
    <!-- END Units and button -->
</div>

